import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';

import {
  applyWalletDeposit,
  checkoutWalletDeposit,
  discardWalletDeposit,
  prepareWalletDeposit
} from '../../ducks/wallet';
import {asMappedSubmissionError} from '../../utils/asSubmissionError';
import {getGaClientId, getGaSessionId} from '../../utils/extractGaClientId';

import Modal from '../../components/modals/Modal';
import Loader from '../../components/loader/Loader';
import WalletDepositModalForm from './WalletDepositModalForm';
import getPublicUrl from '../../utils/getPublicUrl';
import withChannelFormatters from '../channelUtils/withChannelFormatters';
import {getOrderPaymentData} from '../../ducks/order';
import {SubmissionError} from 'redux-form';

@withChannelFormatters
@connect()
export default class WalletDepositModalContainer extends React.PureComponent {
  static modalName = 'walletDeposit';

  static propTypes = {
    onClose: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    const {dispatch} = this.props;

    dispatch(prepareWalletDeposit())
      .then(deposit => this.setState(deposit), error => this.setState({error}));
  }

  componentWillUnmount() {
    const {dispatch} = this.props;
    const {walletCart} = this.state;

    if (walletCart) {
      dispatch(discardWalletDeposit(walletCart));
    }
  }
  applyWalletDeposit = ({quantity}) => {
    const {dispatch} = this.props;
    const {walletCart, walletProduct} = this.state;

    if (!quantity || quantity < 0) {
      throw new SubmissionError({
        'quantity': <FormattedMessage id="section.wallet.quantity.error"/>
      });
    }

    return dispatch(applyWalletDeposit(walletCart, walletProduct, quantity))
      .then(orderResponse => this.setState({cart: orderResponse.content, isApplied: true}))
      .catch(asMappedSubmissionError({
        'payments.0.method': 'checkoutMethod'
      }));
  };

  removeWalletDeposit = () => {
    this.setState({isApplied: false});
  };

  submitWalletDeposit = ({checkoutMethod}) => {
    const {dispatch, channelFormatters} = this.props;
    const {walletCart} = this.state;

    return dispatch(checkoutWalletDeposit(walletCart, checkoutMethod))
      .then(({ content: cart }) => {
        const _cart = cart || walletCart;

        return dispatch(
          getOrderPaymentData(
            _cart.id,
            _cart.tokenValue,
            getPublicUrl() + channelFormatters.link('/profile'),
            getGaClientId(),
            getGaSessionId()
          )
        );
      })
      .then((paymentDataResponse) => (window.location = paymentDataResponse.content.url))
      .catch(
        asMappedSubmissionError({
          'payments.0.method': 'checkoutMethod',
        })
      );
  };

  render() {
    const {onClose} = this.props;
    const {walletProduct, cart, walletCart, error} = this.state;

    const _cart = cart || walletCart;

    return (
      <Modal type="wallet" onClose={onClose}>
        <div className="modal__column-wallet">
          <div className="modal__header">
            <FormattedMessage id="section.wallet.title"/>
          </div>

          {error ? (
            <p className="popup__text">Unavailable</p>
          ) : walletProduct ? (
            <WalletDepositModalForm
              walletCart={_cart}
              checkoutMethods={_cart.payments[_cart.payments.length - 1].methodsAvailable}
              isApplied={this.state.isApplied}
              onApply={this.applyWalletDeposit}
              onRemove={this.removeWalletDeposit}
              onSubmit={this.submitWalletDeposit}
            />
          ) : (
            <Loader/>
          )}
        </div>

      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/walletDepositModalContainer/WalletDepositModalContainer.js